module.exports = __webpack_public_path__ + "img/borusan-carousel.7343235a.png";